import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Label from './FormLabel';

// import '@style/components/projectForm.scss';
import '../../styles/components/projectForm.scss';

function FormItem(props) {
  const { label, children, className } = props;
  return (
    <div className={`form-item-wrapper ${className}`}>
      <div className="form-label-wrapper">
        <Label text={label} />
      </div>
      {children}
    </div>
  );
}

FormItem.defaultProps = {
  label: null,
  className: '',
};

FormItem.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
};

export default memo(FormItem);
